import React from "react";

const Error = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <h1 style={{ fontSize: "3rem", marginBottom: "1rem" }}>Oops, terjadi kesalahan!</h1>
      <p style={{ fontSize: "1.5rem" }}>Maaf, Silahkan Periksa Koneksi Anda / Hubungi Developer.</p>
      <img src="https://neurolink.company/cms/wp-content/uploads/2017/07/canstockphoto24393658-human-error.jpg" alt="Error" style={{ width: "300px", height: "auto" }} />
      <a href="/">Kembali ke Halaman Utama</a>
    </div>
  );
};

export default Error;
